(function () {
  "use strict";

  var INSURANCE_DEDUCTIBLE_TEXT = "Eigen risico \u20AC99,- per gebeurtenis.";
  var KLAVIYO_API_REVISION = "2024-06-15";

  function parseJson(raw, fallback) {
    if (!raw) return fallback;

    try {
      return JSON.parse(raw);
    } catch (error) {
      return fallback;
    }
  }

  function formatMoney(cents, currency) {
    if (typeof cents !== "number" || Number.isNaN(cents)) {
      return "";
    }

    return new Intl.NumberFormat("nl-NL", {
      style: "currency",
      currency: currency || "EUR",
      minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function toStringValue(value) {
    if (value === null || value === undefined) return "";
    return String(value);
  }

  function findProductForm(root) {
    var withinForm = root.closest("form");
    if (withinForm) return withinForm;

    var scopedContainers = [
      root.closest(".product-content-new"),
      root.closest(".main-product__content"),
      root.closest(".main-product"),
      root.parentElement,
      document
    ];

    for (var index = 0; index < scopedContainers.length; index += 1) {
      var container = scopedContainers[index];
      if (!container || typeof container.querySelector !== "function") {
        continue;
      }

      var form =
        container.querySelector('[data-battery-subscription-form="true"]') ||
        container.querySelector('form[data-type="add-to-cart-form"]') ||
        container.querySelector('form[action*="/cart/add"]');

      if (form) {
        return form;
      }
    }

    return null;
  }

  function readVariants(root) {
    var variantsJsonNode = root.querySelector("[data-product-variants-json]");
    return parseJson(variantsJsonNode && variantsJsonNode.textContent, []);
  }

  function readConfig(root) {
    var configNode = root.getAttribute("data-config");
    return parseJson(configNode, {});
  }

  function getCheckedInput(root, selector) {
    var inputs = root.querySelectorAll(selector);
    for (var index = 0; index < inputs.length; index += 1) {
      if (inputs[index] && inputs[index].checked) {
        return inputs[index];
      }
    }

    return null;
  }

  function getMode(root) {
    var checked = getCheckedInput(root, "[data-mode-input]");
    return checked ? checked.value : root.getAttribute("data-default-mode") || "subscription";
  }

  function getInsuranceValue(root) {
    var checked = getCheckedInput(root, "[data-insurance-input]");
    return checked ? checked.value : "none";
  }

  function ensureFieldsInsideForm(root, form) {
    if (!form) return;

    var selectors = [
      "[data-selling-plan-input]",
      "[data-property-mode]",
      "[data-property-battery-count]",
      "[data-property-insurance]",
      "[data-property-monthly]",
      "[data-property-deposit]",
      "[data-property-firmhouse-mode]",
      "[data-property-firmhouse-battery-count]",
      "[data-property-firmhouse-insurance]",
      "[data-property-firmhouse-discount]",
      "[data-property-linked-deposit]"
    ];

    selectors.forEach(function (selector) {
      var field = root.querySelector(selector);
      if (field && field.form !== form) {
        form.appendChild(field);
      }
    });
  }

  function setModeCards(root) {
    var cards = root.querySelectorAll("[data-mode-card]");
    cards.forEach(function (card) {
      var input = card.querySelector("[data-mode-input]");
      card.classList.toggle("is-active", Boolean(input && input.checked));
    });
  }

  function setInsuranceCards(root) {
    var cards = root.querySelectorAll("[data-insurance-card]");
    cards.forEach(function (card) {
      var input = card.querySelector("[data-insurance-input]");
      card.classList.toggle("is-active", Boolean(input && input.checked));
    });
  }

  function getVariantInput(form) {
    return form ? form.querySelector('input[name="id"]') : null;
  }

  function getQuantity(form) {
    var quantityInput = form ? form.querySelector('input[name="quantity"]') : null;
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

    if (!Number.isFinite(quantity) || quantity < 1) {
      return 1;
    }

    return quantity;
  }

  function getSelectedVariant(form, variants) {
    var variantInput = getVariantInput(form);
    var selectedId = variantInput ? variantInput.value : "";

    return variants.find(function (variant) {
      return toStringValue(variant.id) === toStringValue(selectedId);
    }) || variants[0] || null;
  }

  function findVariantById(variants, variantId) {
    if (!variantId || !variants || !variants.length) {
      return null;
    }

    return variants.find(function (variant) {
      return toStringValue(variant.id) === toStringValue(variantId);
    }) || null;
  }

  function getBatteryCountFromVariant(config, variant) {
    if (!variant) return null;

    var mappedCounts = config && config.variant_battery_count_map ? config.variant_battery_count_map : {};
    var directMap = mappedCounts[toStringValue(variant.id)];
    if (directMap) {
      return toStringValue(directMap);
    }

    var title = toStringValue(variant.title).toLowerCase();
    if (title.indexOf("2 batter") !== -1) return "2";
    if (title.indexOf("1 batter") !== -1) return "1";

    var options = [variant.option1, variant.option2, variant.option3];
    var optionMatch = options.find(function (value) {
      var normalized = toStringValue(value).toLowerCase();
      return normalized.indexOf("1 batter") !== -1 || normalized.indexOf("2 batter") !== -1;
    });

    if (!optionMatch) {
      return null;
    }

    return optionMatch.toLowerCase().indexOf("2 batter") !== -1 ? "2" : "1";
  }

  function getBatteryEntry(config, batteryCount) {
    if (!config || !config.battery_counts) return null;
    return config.battery_counts[toStringValue(batteryCount)] || null;
  }

  function getInsuranceOptions(entry) {
    if (!entry) return {};
    return entry.insurance_options || entry.insurance || {};
  }

  function getInsuranceEntry(entry, insuranceValue) {
    var insuranceOptions = getInsuranceOptions(entry);
    return insuranceOptions[toStringValue(insuranceValue)] || insuranceOptions.none || null;
  }

  function getSubscriptionAvailabilityCache(root) {
    if (!root.__firmhouseSubscriptionAvailability) {
      root.__firmhouseSubscriptionAvailability = {};
    }

    return root.__firmhouseSubscriptionAvailability;
  }

  function getCachedSubscriptionAvailability(root, variantId) {
    if (!variantId) return null;

    var record = getSubscriptionAvailabilityCache(root)[toStringValue(variantId)];
    if (!record) return null;
    if (record.status === "available") return true;
    if (record.status === "unavailable") return false;
    if (record.status === "error") return "error";
    return null;
  }

  function getVariantAvailabilityUrl(variantId) {
    var routeRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    if (routeRoot.charAt(routeRoot.length - 1) !== "/") {
      routeRoot += "/";
    }

    return routeRoot + "variants/" + encodeURIComponent(toStringValue(variantId)) + ".js";
  }

  function requestSubscriptionAvailability(root, state, rerender) {
    if (!state || state.mode !== "subscription" || !state.subscriptionVariantId) {
      return;
    }

    var variantId = toStringValue(state.subscriptionVariantId);
    var cache = getSubscriptionAvailabilityCache(root);
    var existing = cache[variantId];

    if (existing && existing.status !== "error") {
      return;
    }

    if (existing && existing.status === "error" && Date.now() - existing.updatedAt < 30000) {
      return;
    }

    cache[variantId] = { status: "pending", updatedAt: Date.now() };

    fetch(getVariantAvailabilityUrl(variantId), {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Variantbeschikbaarheid kon niet worden opgehaald.");
        }
        return response.json();
      })
      .then(function (variant) {
        cache[variantId] = {
          status: variant && variant.available ? "available" : "unavailable",
          updatedAt: Date.now()
        };
        rerender();
      })
      .catch(function (error) {
        cache[variantId] = { status: "error", updatedAt: Date.now() };
        console.error("[Firmhouse PDP] subscription availability check failed", error);
        rerender();
      });
  }

  function getOneTimeVehicleVariantMap(entry) {
    if (!entry) return {};

    return (
      entry.one_time_vehicle_variant_map ||
      entry.one_time_vehicle_variant_id_map ||
      entry.one_time_vehicle_variant_by_source_variant_id ||
      entry.one_time_vehicle_variant_id_by_source_variant_id ||
      entry.purchase_vehicle_variant_map ||
      {}
    );
  }

  function getOneTimeVehicleVariantId(entry, sourceVariant) {
    if (!entry) return "";

    var sourceVariantId = sourceVariant ? toStringValue(sourceVariant.id) : "";
    var mappedVariantIds = getOneTimeVehicleVariantMap(entry);

    if (sourceVariantId && mappedVariantIds[sourceVariantId]) {
      return mappedVariantIds[sourceVariantId];
    }

    return (
      entry.one_time_vehicle_product_variant_id ||
      entry.one_time_vehicle_variant_id ||
      entry.purchase_vehicle_product_variant_id ||
      entry.purchase_vehicle_variant_id ||
      ""
    );
  }

  // Subscription-mode vehicles can render a visible PDP variant, while checkout uses a hidden
  // one-time purchase variant with its own price. For products with color variants, the hidden
  // one-time variant can be mapped per visible source variant via one_time_vehicle_variant_map.
  // Prefer explicit config first, then the hidden variant price, and only then fall back to a
  // discount-based calculation.
  function getOneTimeVehiclePriceCents(entry, fallbackBasePriceCents, variants, sourceVariant) {
    if (!entry) return 0;

    var explicitPrice =
      entry.one_time_vehicle_price_cents !== undefined && entry.one_time_vehicle_price_cents !== null
        ? Number(entry.one_time_vehicle_price_cents)
        : null;

    if (Number.isFinite(explicitPrice) && explicitPrice >= 0) {
      return explicitPrice;
    }

    var oneTimeVariant = findVariantById(variants, getOneTimeVehicleVariantId(entry, sourceVariant));
    if (oneTimeVariant) {
      var variantPrice = Number(oneTimeVariant.price || 0);
      if (Number.isFinite(variantPrice) && variantPrice >= 0) {
        return variantPrice;
      }
    }

    var rawValue =
      Number(fallbackBasePriceCents || 0) + Number(entry.vehicle_discount_cents || 0);
    var parsedValue = Number(rawValue);

    if (!Number.isFinite(parsedValue) || parsedValue < 0) {
      return 0;
    }

    return parsedValue;
  }

  function getMonthlyPriceCents(entry) {
    if (!entry) return null;

    if (typeof entry.monthly_price_cents === "number") {
      return entry.monthly_price_cents;
    }

    if (typeof entry.selling_plan_price_cents === "number") {
      return entry.selling_plan_price_cents;
    }

    return null;
  }

  function setField(root, selector, value) {
    var field = root.querySelector(selector);
    if (field) {
      field.value = value;
    }
  }

  function renderText(root, selector, value) {
    var node = root.querySelector(selector);
    if (node) {
      node.textContent = value;
    }
  }

  function renderDepositLabel(root, batteryCount) {
    var labelNode = root.querySelector("[data-deposit-label]");
    if (!labelNode) {
      return;
    }

    labelNode.textContent = toStringValue(batteryCount) === "2" ? "Borg per batterij" : "Borg batterij";
  }

  function renderTotalDepositRow(root, batteryCount) {
    var rowNode = root.querySelector("[data-total-deposit-row]");
    if (!rowNode) {
      return;
    }

    rowNode.hidden = toStringValue(batteryCount) !== "2";
  }

  function formatMoneyCompact(cents) {
    if (typeof cents !== "number" || Number.isNaN(cents)) {
      return "";
    }

    var formatted = formatMoney(cents);
    return formatted.replace(",00", ",-");
  }

  function getInsuranceInsuredLabel(state, insurancePriceDeltaCents) {
    var batteryCount = toStringValue(state.batteryCount) === "2" ? "2 batterijen" : "1 batterij";
    var monthlyPriceText = insurancePriceDeltaCents !== null ? formatMoneyCompact(insurancePriceDeltaCents) : "";
    var suffix = monthlyPriceText ? ", " + monthlyPriceText + " per maand" : "";
    return "Schade- en diefstalverzekering " + batteryCount + suffix + ". " + INSURANCE_DEDUCTIBLE_TEXT;

  }

  function getMainPriceContainer(root) {
    return (
      root.closest(".product-content-new") ||
      root.closest(".main-product__content") ||
      document
    );
  }

  function getMainPriceNode(root) {
    var container = getMainPriceContainer(root);
    if (!container || typeof container.querySelector !== "function") {
      return null;
    }

    return container.querySelector(
      ".product-content-new__price .xo-price__regular .xo-price__item, .product-content-new__price .xo-price__sale .xo-price__item:not(.xo-price__item--del)"
    );
  }

  function getDisplayedMainPriceText(state) {
    return formatMoney(state.mode === "subscription" ? state.cartTotalCents : state.vehiclePriceCents);
  }

  function renderMainPrice(root, state) {
    var mainPriceNode = getMainPriceNode(root);

    if (!mainPriceNode) {
      return;
    }

    mainPriceNode.textContent = getDisplayedMainPriceText(state);
  }

  function getInsurancePriceDeltaCents(insuranceOptions) {
    if (!insuranceOptions) {
      return null;
    }

    var noneEntry = insuranceOptions.none || null;
    var insuredEntry = insuranceOptions.insured || null;
    var nonePrice = getMonthlyPriceCents(noneEntry);
    var insuredPrice = getMonthlyPriceCents(insuredEntry);

    if (nonePrice === null || insuredPrice === null) {
      return null;
    }

    var delta = Number(insuredPrice) - Number(nonePrice);
    if (!Number.isFinite(delta) || delta <= 0) {
      return null;
    }

    return delta;
  }

  function renderInsuranceOptions(root, state) {
    var section = root.querySelector("[data-insurance-section]");
    if (!section) return;

    var descriptionNode = root.querySelector("[data-insurance-description]");
    var noneLabelNode = root.querySelector("[data-insurance-none-label]");
    var insuredLabelNode = root.querySelector("[data-insurance-insured-label]");
    var insuredEntry = state.insuranceOptions.insured || null;
    var insurancePriceDeltaCents = getInsurancePriceDeltaCents(state.insuranceOptions);

    if (descriptionNode) {
      if (insurancePriceDeltaCents !== null) {
        descriptionNode.textContent =
          "Voeg extra bescherming toe voor " + formatMoney(insurancePriceDeltaCents) + " per maand.";
      } else {
        descriptionNode.textContent = "Kies of je jouw batterijen extra wilt verzekeren.";
      }
    }

    if (noneLabelNode) {
      noneLabelNode.textContent = "Ik verzeker de batterij(en) zelf bij mijn voertuig";
    }

    if (insuredLabelNode) {
      insuredLabelNode.textContent =
        insuredEntry
          ? getInsuranceInsuredLabel(state, insurancePriceDeltaCents)
          : "Schade- en diefstalverzekering";
    }

    section.hidden = state.mode !== "subscription";

    var insuredInput = root.querySelector('[data-insurance-input][value="insured"]');
    if (insuredInput) {
      insuredInput.disabled = !insuredEntry;
      if (!insuredEntry && insuredInput.checked) {
        var noneInput = root.querySelector('[data-insurance-input][value="none"]');
        if (noneInput) {
          noneInput.checked = true;
        }
      }
    }

    setInsuranceCards(root);
  }

  function renderSummary(root, state) {
    var summary = root.querySelector("[data-subscription-summary]");
    var summaryTextNode = root.querySelector("[data-summary-text]");
    var footerNode = root.querySelector("[data-summary-footer]");
    if (!summary) return;

    summary.hidden = false;
    renderDepositLabel(root, state.batteryCount);
    renderTotalDepositRow(root, state.batteryCount);

    if (state.mode !== "subscription") {
      if (summaryTextNode) {
        summaryTextNode.textContent = "Zonder batterij-abonnement betaal je alleen de volledige voertuigprijs.";
      }
      if (footerNode) {
        footerNode.textContent = "Geen maandbedrag en geen borg.";
      }
      renderText(root, "[data-vehicle-price]", formatMoney(state.vehiclePriceCents));
      renderText(root, "[data-monthly-price]", "-");
      renderText(root, "[data-deposit-per-battery]", "-");
      renderText(root, "[data-total-deposit]", "-");
      return;
    }

    if (summaryTextNode) {
      summaryTextNode.textContent = "Het maandbedrag en de borg hangen af van je gekozen configuratie.";
    }
    if (footerNode) {
      footerNode.textContent = "Slimmer rijden. Minder betalen.";
    }
    renderText(root, "[data-vehicle-price]", formatMoney(state.vehiclePriceCents));
    renderText(root, "[data-monthly-price]", state.monthlyPriceLabel);
    renderText(root, "[data-deposit-per-battery]", formatMoney(state.depositPerBatteryCents));
    renderText(root, "[data-total-deposit]", formatMoney(state.totalDepositCents));
  }

  function getPurchaseUi(root, form) {
    var container = getMainPriceContainer(root);
    return {
      cartAdd: form ? form.querySelector(".product-content-new__cart-add") : null,
      notifyButton: form ? form.querySelector("[data-battery-back-in-stock-trigger]") : null,
      status: form ? form.querySelector("[data-battery-availability-status]") : null,
      dialog:
        container && typeof container.querySelector === "function"
          ? container.querySelector("[data-battery-back-in-stock-dialog]")
          : null
    };
  }

  function renderPurchaseAvailability(root, form, state) {
    var ui = getPurchaseUi(root, form);
    var isSubscription = state.mode === "subscription";
    var isAvailable = state.subscriptionAvailability === true;
    var isUnavailable = state.subscriptionAvailability === false;
    var hasError = state.subscriptionAvailability === "error";

    if (ui.cartAdd) {
      ui.cartAdd.hidden = isSubscription && !isAvailable;
    }

    if (ui.notifyButton) {
      ui.notifyButton.hidden = !isSubscription || !isUnavailable;
      ui.notifyButton.setAttribute("data-subscription-variant-id", toStringValue(state.subscriptionVariantId));
    }

    if (ui.dialog) {
      ui.dialog.setAttribute("data-subscription-variant-id", toStringValue(state.subscriptionVariantId));
    }

    if (!ui.status) return;

    if (!isSubscription || isAvailable) {
      ui.status.textContent = "";
      ui.status.hidden = true;
      return;
    }

    if (isUnavailable) {
      ui.status.textContent = "Ontvang een bericht zodra dit product weer op voorraad is.";
    } else if (hasError) {
      ui.status.textContent = "We kunnen de beschikbaarheid nu niet controleren. Probeer het later opnieuw.";
    } else {
      ui.status.textContent = "Beschikbaarheid controleren…";
    }
    ui.status.hidden = false;
  }

  function syncFields(root, state) {
    setField(root, "[data-selling-plan-input]", state.sellingPlanId ? toStringValue(state.sellingPlanId) : "");
    setField(root, "[data-property-mode]", state.modeLabel);
    setField(root, "[data-property-battery-count]", state.batteryCount ? toStringValue(state.batteryCount) : "");
    setField(root, "[data-property-insurance]", state.mode === "subscription" ? state.insuranceLabel : "");
    setField(root, "[data-property-monthly]", state.mode === "subscription" ? state.monthlyPriceLabel : "");
    setField(root, "[data-property-deposit]", state.mode === "subscription" ? formatMoney(state.totalDepositCents) : "");
    setField(root, "[data-property-firmhouse-mode]", state.mode);
    setField(root, "[data-property-firmhouse-battery-count]", state.batteryCount ? toStringValue(state.batteryCount) : "");
    setField(root, "[data-property-firmhouse-insurance]", state.mode === "subscription" ? state.insuranceValue : "");
    setField(root, "[data-property-firmhouse-discount]", state.mode === "subscription" ? toStringValue(state.vehicleDiscountCents) : "");
    setField(root, "[data-property-linked-deposit]", state.mode === "subscription" ? toStringValue(state.depositVariantId) : "");
  }

  function buildState(root, form, variants, config) {
    var selectedVariant = getSelectedVariant(form, variants);
    var mode = getMode(root);
    var insuranceValue = getInsuranceValue(root);
    var batteryCount = getBatteryCountFromVariant(config, selectedVariant) || "1";
    var batteryEntry = getBatteryEntry(config, batteryCount);
    var insuranceOptions = getInsuranceOptions(batteryEntry);
    var insuranceEntry = getInsuranceEntry(batteryEntry, insuranceValue);
    var basePrice = selectedVariant ? Number(selectedVariant.price || 0) : 0;
    var vehicleDiscountCents = batteryEntry ? Number(batteryEntry.vehicle_discount_cents || 0) : 0;
    var oneTimeVehicleVariantId = getOneTimeVehicleVariantId(batteryEntry, selectedVariant);
    var oneTimeVehiclePriceCents = getOneTimeVehiclePriceCents(batteryEntry, basePrice, variants, selectedVariant);
    var depositCents = batteryEntry ? Number(batteryEntry.deposit_cents || 0) : 0;
    var depositVariantId = batteryEntry ? batteryEntry.deposit_product_variant_id : "";
    var monthlyPriceCents = getMonthlyPriceCents(insuranceEntry || batteryEntry);
    var sellingPlanId = insuranceEntry && insuranceEntry.selling_plan_id ? insuranceEntry.selling_plan_id : "";
    var subscriptionVariantId =
      insuranceEntry && (insuranceEntry.subscription_product_variant_id || insuranceEntry.subscription_variant_id)
        ? insuranceEntry.subscription_product_variant_id || insuranceEntry.subscription_variant_id
        : "";
    var subscriptionAvailability =
      mode === "subscription"
        ? getCachedSubscriptionAvailability(root, subscriptionVariantId)
        : true;
    var totalDepositCents = depositCents;
    var vehiclePriceCents = basePrice;
    var insuranceLabel = insuranceValue === "insured" ? "Met batterijverzekering" : "Zonder batterijverzekering";
    var cartVehicleVariantId = selectedVariant ? selectedVariant.id : "";

    if (mode !== "subscription") {
      vehiclePriceCents = oneTimeVehiclePriceCents;
      cartVehicleVariantId = oneTimeVehicleVariantId;
    }

    return {
      mode: mode,
      modeLabel: mode === "subscription" ? "Met batterij-abonnement" : "Zonder batterij-abonnement",
      insuranceValue: insuranceValue,
      insuranceLabel: insuranceLabel,
      insuranceOptions: insuranceOptions,
      batteryCount: batteryCount,
      selectedVariantId: selectedVariant ? selectedVariant.id : "",
      cartVehicleVariantId: cartVehicleVariantId,
      quantity: getQuantity(form),
      basePriceCents: basePrice,
      vehiclePriceCents: vehiclePriceCents,
      vehicleDiscountCents: vehicleDiscountCents,
      oneTimeVehicleVariantId: mode === "subscription" ? "" : oneTimeVehicleVariantId,
      oneTimeVehiclePriceCents: mode === "subscription" ? 0 : oneTimeVehiclePriceCents,
      depositPerBatteryCents: batteryCount === "2" ? Math.round(depositCents / 2) : depositCents,
      totalDepositCents: totalDepositCents,
      depositVariantId: depositVariantId,
      subscriptionVariantId: mode === "subscription" ? subscriptionVariantId : "",
      subscriptionAvailability: subscriptionAvailability,
      sellingPlanId: mode === "subscription" ? sellingPlanId : "",
      monthlyPriceCents: monthlyPriceCents,
      monthlyPriceLabel: monthlyPriceCents !== null ? formatMoney(monthlyPriceCents) : "Via selling plan configuratie",
      cartTotalCents:
        mode === "subscription"
          ? vehiclePriceCents + Number(monthlyPriceCents || 0) + totalDepositCents
          : vehiclePriceCents,
      productTitle: root.getAttribute("data-product-title") || ""
    };
  }

  function buildVehicleProperties(state) {
    return {
      "Aankooptype": state.modeLabel,
      "Aantal batterijen": toStringValue(state.batteryCount),
      "Verzekering": state.mode === "subscription" ? state.insuranceLabel : "",
      "_firmhouse_mode": state.mode,
      "_firmhouse_battery_count": toStringValue(state.batteryCount),
      "_firmhouse_insurance": state.mode === "subscription" ? state.insuranceValue : "",
      "_firmhouse_vehicle_discount_cents": state.mode === "subscription" ? toStringValue(state.vehicleDiscountCents) : "",
      "_source_vehicle_variant_id": toStringValue(state.selectedVariantId),
      "_linked_subscription_variant_id": state.mode === "subscription" ? toStringValue(state.subscriptionVariantId) : "",
      "_linked_deposit_variant_id": state.mode === "subscription" ? toStringValue(state.depositVariantId) : ""
    };
  }

  function buildSubscriptionProperties(state) {
    return {
      "Type": "Batterij abonnement",
      "Aantal batterijen": toStringValue(state.batteryCount),
      "Verzekering": state.insuranceLabel,
      "Maandbedrag": state.monthlyPriceLabel,
      "_linked_vehicle_variant_id": toStringValue(state.selectedVariantId),
      "_linked_deposit_variant_id": toStringValue(state.depositVariantId)
    };
  }

  function buildCartPayload(state) {
    var vehicleItem = {
      id: state.cartVehicleVariantId,
      quantity: state.quantity,
      properties: buildVehicleProperties(state)
    };

    if (state.mode !== "subscription") {
      return { items: [vehicleItem] };
    }

    return {
      items: [
        {
          id: state.subscriptionVariantId,
          quantity: state.quantity,
          selling_plan: state.sellingPlanId,
          properties: buildSubscriptionProperties(state)
        },
        {
          id: state.depositVariantId,
          quantity: state.quantity,
          properties: {
            "Type": "Borg batterij abonnement",
            "Voor product": state.productTitle,
            "_linked_vehicle_variant_id": toStringValue(state.selectedVariantId)
          }
        },
        vehicleItem
      ]
    };
  }

  function getCrossSellRequests(root, state) {
    var container = root.closest(".product-content-new") || document;
    var selectedCheckboxes = container.querySelectorAll(".product-content-new__cross-sell-checkbox:checked");

    return Array.prototype.slice.call(selectedCheckboxes)
      .map(function (checkbox) {
        var variantId = checkbox.getAttribute("data-variant-id");
        if (!variantId) return null;

        return {
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                "_linked_vehicle_variant_id": toStringValue(state.selectedVariantId),
                "_pdp_cross_sell": "true"
              }
            }
          ]
        };
      })
      .filter(function (payload) {
        return Boolean(payload);
      });
  }

  function buildCartRequests(root, state) {
    var payload = buildCartPayload(state);
    var itemRequests = payload.items.map(function (item) {
      return {
        items: [item]
      };
    });

    return itemRequests.concat(getCrossSellRequests(root, state));
  }

  function buildFormDataPayload(item) {
    var formData = new FormData();

    formData.append("id", toStringValue(item.id));
    formData.append("quantity", toStringValue(item.quantity || 1));

    if (item.selling_plan) {
      formData.append("selling_plan", toStringValue(item.selling_plan));
    }

    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        formData.append("properties[" + key + "]", toStringValue(item.properties[key]));
      });
    }

    return formData;
  }

  function dispatchEvent(root, name, detail) {
    root.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: detail
      })
    );
  }

  function submitSingleCartPayload(root, payload) {
    window.__firmhousePdpLastPayload = payload;

    var firstItem = payload && payload.items ? payload.items[0] : null;
    var hasSellingPlan = Boolean(firstItem && firstItem.selling_plan);
    var requestOptions = {
      method: "POST",
      headers: {
        Accept: "application/json"
      }
    };

    if (hasSellingPlan && payload.items.length === 1) {
      requestOptions.body = buildFormDataPayload(firstItem);
    } else {
      requestOptions.headers["Content-Type"] = "application/json";
      requestOptions.body = JSON.stringify(payload);
    }

    return fetch("/cart/add.js", requestOptions)
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function (rawText) {
            var message = "Cart add failed";
            var parsed = null;

            try {
              parsed = rawText ? JSON.parse(rawText) : null;
            } catch (error) {
              parsed = null;
            }

            if (parsed) {
              message = parsed.description || parsed.message || parsed.errors || rawText || message;
            } else if (rawText) {
              message = rawText;
            }

            if (typeof message !== "string") {
              message = JSON.stringify(message);
            }

            console.error("[Firmhouse PDP] cart add failed", {
              status: response.status,
              statusText: response.statusText,
              payload: payload,
              responseText: rawText
            });
            window.__firmhousePdpLastError = {
              status: response.status,
              statusText: response.statusText,
              payload: payload,
              responseText: rawText
            };

            throw new Error(message);
          });
        }

        return response.json();
      })
      .then(function (data) {
        window.__firmhousePdpLastSuccess = {
          payload: payload,
          response: data
        };
        dispatchEvent(root, "battery-subscription:cart-success", {
          payload: payload,
          response: data
        });
        return data;
      })
      .catch(function (error) {
        dispatchEvent(root, "battery-subscription:cart-error", {
          payload: payload,
          error: error
        });
        throw error;
      });
  }

  function submitCartPayload(root, state) {
    var payloads = buildCartRequests(root, state);
    var results = [];

    return payloads.reduce(function (promise, payload) {
      return promise.then(function () {
        return submitSingleCartPayload(root, payload).then(function (result) {
          results.push(result);
        });
      });
    }, Promise.resolve()).then(function () {
      return results;
    });
  }

  function setSubmittingState(form, isSubmitting) {
    if (!form) return;

    var buttons = form.querySelectorAll(
      ".product-content-new__cart-add, .product-content-new__add-to-cart button, button[type='submit']"
    );

    buttons.forEach(function (button) {
      if (!button) return;

      if (isSubmitting) {
        button.setAttribute("disabled", "disabled");
        button.setAttribute("aria-busy", "true");
      } else {
        button.removeAttribute("disabled");
        button.removeAttribute("aria-busy");
      }
    });
  }

  function getSubmissionError(state) {
    if (!state.selectedVariantId) {
      return "Geen voertuigvariant geselecteerd.";
    }

    if (state.mode !== "subscription" && !state.oneTimeVehicleVariantId) {
      return "Zonder batterij abonnement vereist een verborgen koopvariant met de volledige voertuigprijs.";
    }

    if (state.mode === "subscription" && !state.sellingPlanId) {
      return "Geen geldig selling plan gevonden voor deze batterij- en verzekeringskeuze.";
    }

    if (state.mode === "subscription" && !state.subscriptionVariantId) {
      return "Geen geldig batterij-abonnement product gevonden voor deze batterij- en verzekeringskeuze.";
    }

    if (state.mode === "subscription" && !state.depositVariantId) {
      return "Geen geldig borgproduct gevonden voor deze batterijkeuze.";
    }

    if (state.mode === "subscription" && state.subscriptionAvailability !== true) {
      return state.subscriptionAvailability === false
        ? "Het gekozen batterij-abonnement is tijdelijk niet beschikbaar."
        : "De beschikbaarheid van het batterij-abonnement kon nog niet worden bevestigd.";
    }

    return "";
  }

  function wireBackInStock(root, form, getState) {
    var container = getMainPriceContainer(root);
    if (!container || typeof container.querySelector !== "function") return;

    // Shopify's product components can replace the purchase button after initialization.
    // Keep the current state getters on the stable product container and delegate events so
    // replacement buttons and forms continue to work without reinitializing the integration.
    container._batteryBackInStockGetState = getState;
    container._batteryBackInStockRoot = root;

    if (container._batteryBackInStockWired) return;
    container._batteryBackInStockWired = true;

    var previousFocus = null;

    function setFeedback(dialog, message, isError) {
      var feedback = dialog.querySelector("[data-battery-back-in-stock-feedback]");
      if (!feedback) return;
      feedback.textContent = message || "";
      feedback.hidden = !message;
      feedback.classList.toggle("is-error", Boolean(message && isError));
      feedback.classList.toggle("is-success", Boolean(message && !isError));
    }

    function openDialog(dialog) {
      var stateGetter = container._batteryBackInStockGetState;
      var state = typeof stateGetter === "function" ? stateGetter() : null;
      if (!state || state.mode !== "subscription" || state.subscriptionAvailability !== false) {
        return;
      }

      var panel = dialog.querySelector(".battery-back-in-stock__panel");
      var emailInput = dialog.querySelector("[data-battery-back-in-stock-email]");
      dialog.setAttribute("data-subscription-variant-id", toStringValue(state.subscriptionVariantId));
      previousFocus = document.activeElement;
      dialog.hidden = false;
      document.documentElement.classList.add("battery-back-in-stock-open");
      window.requestAnimationFrame(function () {
        if (emailInput) emailInput.focus();
        else if (panel) panel.focus();
      });
    }

    function closeDialog(dialog) {
      dialog.hidden = true;
      document.documentElement.classList.remove("battery-back-in-stock-open");
      if (previousFocus && typeof previousFocus.focus === "function") {
        previousFocus.focus();
      }
    }

    container.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") return;

      var trigger = target.closest("[data-battery-back-in-stock-trigger]");
      if (trigger && container.contains(trigger)) {
        var currentDialog = container.querySelector("[data-battery-back-in-stock-dialog]");
        if (currentDialog) openDialog(currentDialog);
        return;
      }

      var closeButton = target.closest("[data-battery-back-in-stock-close]");
      if (closeButton && container.contains(closeButton)) {
        var dialogToClose = closeButton.closest("[data-battery-back-in-stock-dialog]");
        if (dialogToClose) closeDialog(dialogToClose);
      }
    });

    document.addEventListener("keydown", function (event) {
      var currentDialog = container.querySelector("[data-battery-back-in-stock-dialog]");
      if (currentDialog && !currentDialog.hidden && event.key === "Escape") {
        closeDialog(currentDialog);
      }
    });

    container.addEventListener("submit", function (event) {
      var signupForm = event.target;
      if (!signupForm || !signupForm.matches("[data-battery-back-in-stock-form]")) return;

      event.preventDefault();
      var dialog = signupForm.closest("[data-battery-back-in-stock-dialog]");
      if (!dialog) return;

      var emailInput = signupForm.querySelector("[data-battery-back-in-stock-email]");
      var submitButton = signupForm.querySelector("[data-battery-back-in-stock-submit]");
      if (!emailInput || !submitButton) return;

      setFeedback(dialog, "", false);

      if (!emailInput.checkValidity()) {
        emailInput.reportValidity();
        return;
      }

      var variantId = dialog.getAttribute("data-subscription-variant-id");
      var publicApiKey = dialog.getAttribute("data-klaviyo-public-api-key");
      if (!variantId || !publicApiKey) {
        setFeedback(dialog, "Aanmelden lukt nu niet. Probeer het later opnieuw.", true);
        return;
      }

      var payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email: emailInput.value.trim() }
              }
            },
            channels: ["EMAIL"]
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::" + toStringValue(variantId)
              }
            }
          }
        }
      };

      submitButton.disabled = true;
      submitButton.setAttribute("aria-busy", "true");

      new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        var endpoint =
          "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
          encodeURIComponent(publicApiKey);

        request.open("POST", endpoint, true);
        request.setRequestHeader("Content-Type", "application/json");
        request.setRequestHeader("revision", KLAVIYO_API_REVISION);
        request.timeout = 15000;

        request.onload = function () {
          if (request.status >= 200 && request.status < 300) {
            resolve();
            return;
          }

          var detail = "Back in stock subscription failed";
          try {
            var body = request.responseText ? JSON.parse(request.responseText) : null;
            if (body && body.errors && body.errors[0] && body.errors[0].detail) {
              detail = body.errors[0].detail;
            }
          } catch (error) {
            // Keep the generic error when Klaviyo does not return JSON.
          }

          reject(new Error(detail + " (" + request.status + ")"));
        };
        request.onerror = function () {
          reject(new Error("Back in stock subscription network request failed"));
        };
        request.ontimeout = function () {
          reject(new Error("Back in stock subscription request timed out"));
        };
        request.send(JSON.stringify(payload));
      })
        .then(function () {
          signupForm.hidden = true;
          setFeedback(dialog, "Gelukt. Je ontvangt een e-mail zodra dit product weer op voorraad is.", false);
          dispatchEvent(container._batteryBackInStockRoot || root, "battery-subscription:back-in-stock-success", {
            variantId: variantId
          });
        })
        .catch(function (error) {
          console.error("[Firmhouse PDP] back in stock signup failed", error);
          setFeedback(dialog, "Aanmelden is niet gelukt. Controleer je e-mailadres of probeer het later opnieuw.", true);
        })
        .finally(function () {
          submitButton.disabled = false;
          submitButton.removeAttribute("aria-busy");
        });
    });
  }

  // Theme scripts update variant inputs asynchronously, so we rerender a few times to catch late
  // input/value mutations from Shopify and the surrounding theme components.
  function scheduleRerender(rerender) {
    window.requestAnimationFrame(rerender);
    window.setTimeout(rerender, 0);
    window.setTimeout(rerender, 60);
    window.setTimeout(rerender, 180);
  }

  function handleModeStateChange(root, rerender) {
    setModeCards(root);
    scheduleRerender(rerender);
  }

  function handleInsuranceStateChange(root, rerender) {
    setInsuranceCards(root);
    scheduleRerender(rerender);
  }

  function wireModeChanges(root, rerender) {
    var inputs = root.querySelectorAll("[data-mode-input]");
    inputs.forEach(function (input) {
      input.addEventListener("change", function () {
        handleModeStateChange(root, rerender);
      });
    });
  }

  function wireInsuranceChanges(root, rerender) {
    var inputs = root.querySelectorAll("[data-insurance-input]");
    inputs.forEach(function (input) {
      input.addEventListener("change", function () {
        handleInsuranceStateChange(root, rerender);
      });
    });
  }

  function wireCardDelegation(root, rerender) {
    root.addEventListener("change", function (event) {
      var target = event.target;
      if (!target || typeof target.matches !== "function") {
        return;
      }

      if (target.matches("[data-mode-input]")) {
        handleModeStateChange(root, rerender);
        return;
      }

      if (target.matches("[data-insurance-input]")) {
        handleInsuranceStateChange(root, rerender);
      }
    });

    root.addEventListener("click", function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== "function") {
        return;
      }

      var modeCard = target.closest("[data-mode-card]");
      if (modeCard) {
        window.setTimeout(function () {
          handleModeStateChange(root, rerender);
        }, 0);
        return;
      }

      var insuranceCard = target.closest("[data-insurance-card]");
      if (insuranceCard) {
        window.setTimeout(function () {
          handleInsuranceStateChange(root, rerender);
        }, 0);
      }
    });
  }

  function wireVariantChanges(form, rerender) {
    if (!form) return;

    form.addEventListener("change", function (event) {
      var target = event.target;
      if (!target) return;

      if (target.name === "id" || target.matches("[name^='options'], select, input[type='radio'], input[type='hidden']")) {
        scheduleRerender(rerender);
      }
    });

    var variantInput = getVariantInput(form);
    if (!variantInput) return;

    variantInput.addEventListener("input", function () {
      scheduleRerender(rerender);
    });

    variantInput.addEventListener("change", function () {
      scheduleRerender(rerender);
    });

    if (typeof MutationObserver === "function") {
      var observer = new MutationObserver(function () {
        scheduleRerender(rerender);
      });

      observer.observe(variantInput, {
        attributes: true,
        attributeFilter: ["value"]
      });
    }
  }

  function wireMainPriceObserver(root, getState, rerender) {
    if (typeof MutationObserver !== "function") {
      return;
    }

    var target = getMainPriceContainer(root);
    if (!target || typeof target.querySelector !== "function") {
      return;
    }

    var observer = new MutationObserver(function () {
      var state = getState();
      var mainPriceNode = getMainPriceNode(root);
      if (!state || !mainPriceNode) {
        return;
      }

      if (mainPriceNode.textContent !== getDisplayedMainPriceText(state)) {
        scheduleRerender(rerender);
      }
    });

    observer.observe(target, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function wireSubmit(root, form, getState) {
    if (!form) return;

    var isSubmitting = false;
    var cartAddSelector = ".product-content-new__cart-add";

    function handleSubmit(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
      }

      if (isSubmitting) {
        return;
      }

      var state = getState();
      var submissionError = getSubmissionError(state);

      if (submissionError) {
        window.alert(submissionError);
        return;
      }

      isSubmitting = true;
      setSubmittingState(form, true);

      submitCartPayload(root, state)
        .then(function () {
          window.location.href = "/cart";
        })
        .catch(function (error) {
          console.error("[Firmhouse PDP] submit failed", error);
          window.alert("Toevoegen aan winkelwagen is mislukt: " + error.message);
          throw error;
        })
        .finally(function () {
          isSubmitting = false;
          setSubmittingState(form, false);
        });
    }

    function shouldHandleClick(event) {
      if (!event || !event.target || typeof event.target.closest !== "function") {
        return false;
      }

      var cartAddTrigger = event.target.closest(cartAddSelector);
      if (!cartAddTrigger) {
        return false;
      }

      return form.contains(cartAddTrigger);
    }

    function handleCartAddClick(event) {
      if (!shouldHandleClick(event)) {
        return;
      }

      handleSubmit(event);
    }

    form.addEventListener(
      "submit",
      function (event) {
        handleSubmit(event);
      },
      true
    );

    form.addEventListener("click", handleCartAddClick, true);
    document.addEventListener("click", handleCartAddClick, true);

    var buttonElement = form.querySelector(".product-content-new__add-to-cart button");
    if (buttonElement) {
      buttonElement.addEventListener(
        "click",
        function (event) {
          handleSubmit(event);
        },
        true
      );
    }
  }

  function init(root) {
    var config = readConfig(root);
    var variants = readVariants(root);
    var form = findProductForm(root);

    if (!variants.length) {
      return;
    }

    ensureFieldsInsideForm(root, form);

    var currentState = null;
    function rerender() {
      currentState = buildState(root, form, variants, config);
      window.__firmhousePdpLastState = currentState;
      syncFields(root, currentState);
      renderInsuranceOptions(root, currentState);
      renderSummary(root, currentState);
      renderMainPrice(root, currentState);
      renderPurchaseAvailability(root, form, currentState);
      setModeCards(root);
      setInsuranceCards(root);
      dispatchEvent(root, "battery-subscription:state-change", currentState);
      requestSubscriptionAvailability(root, currentState, rerender);
    }

    wireModeChanges(root, rerender);
    wireInsuranceChanges(root, rerender);
    wireCardDelegation(root, rerender);
    wireVariantChanges(form, rerender);
    wireMainPriceObserver(root, function () {
      return currentState || buildState(root, form, variants, config);
    }, rerender);
    wireSubmit(root, form, function () {
      return currentState || buildState(root, form, variants, config);
    });
    wireBackInStock(root, form, function () {
      return currentState || buildState(root, form, variants, config);
    });

    rerender();
  }

  function boot() {
    var roots = document.querySelectorAll("[data-battery-subscription-root]");
    roots.forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
